/* eslint-disable no-unused-vars */
import { CONFIGS } from "CONFIGS";
import { mockOrFetch } from "../../../../utils";
// eslint-disable-next-line jest/no-mocks-import
import mockData from "../../../../../__mocks__/flights-from.json";
import { BRANDS } from "../../../../configs";

const getGateways = (lang, alias, brand, searchkey) => {
	let flightsGatewaysAPI = CONFIGS.FLIGHTS.GATEWAYS.replace("{lang}", lang).replace(
		"{alias}",
		alias
	);

	if (brand?.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		flightsGatewaysAPI = CONFIGS.FLIGHTS_SOV.GATEWAYS.replace("{searchkey}", searchkey);
	}

	return mockOrFetch({ apiUrl: flightsGatewaysAPI, mockData });
};

const getOneWayGateways = (lang, alias, brand, searchkey) => {
	let flightsOneWayGatewaysAPI = CONFIGS.FLIGHTS.ONE_WAY_GATEWAYS.replace("{lang}", lang).replace(
		"{alias}",
		alias
	);

	if (brand?.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		flightsOneWayGatewaysAPI = CONFIGS.FLIGHTS_SOV.GATEWAYS.replace("{searchkey}", searchkey);
	}

	return mockOrFetch({ apiUrl: flightsOneWayGatewaysAPI, mockData });
};

export { getGateways, getOneWayGateways };
export default getGateways;
